import Pikaday from 'pikaday'
import 'pikaday/css/pikaday.css'
import type { AlpineComponent } from 'alpinejs'

export function Datepicker(
  config: Partial<Pikaday.PikadayOptions> = {},
): AlpineComponent<{
  picker: Pikaday | undefined
  init(): void
  discard(): void
  formatDate(date: Date): string
}> {
  return {
    picker: undefined,

    init() {
      if (!this.$refs.input) {
        console.warn('Datepicker: No input field found.')
        return
      }

      // Use existing input value as initial date if available
      let initialDate = this.$refs.input.dataset.initialDate || null
      let parsedDate = initialDate ? new Date(initialDate) : null

      this.picker = new Pikaday({
        field: this.$refs.input,
        format: 'YYYY-MM-DD',
        firstDay: 1,
        showMonthAfterYear: true,
        yearRange: [1900, new Date().getFullYear()],
        onSelect: (date: Date) => {
          // Format the selected date as MM/DD/YY
          const formattedDate = new Intl.DateTimeFormat('en-US', {
            year: '2-digit',
            month: 'numeric',
            day: 'numeric',
          }).format(date)

          this.$refs.input.value = formattedDate
        },
        ...config,
      })

      // If there's an initial date, set it in Pikaday and update the input
      if (parsedDate) {
        this.$refs.input!.value = this.formatDate(parsedDate)
      }
    },

    discard() {
      this.picker?.destroy()
    },

    formatDate(date: Date) {
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    },
  }
}
